import deleteIcon from "assets/deleteIcon.png"
export const images = {
    deleteIcon
}